import BaseEntity from './BaseEntity';
export default class GhaInstallation extends BaseEntity {
    constructor(data) {
        super();
        this.login = this.parseProperty(data, 'login');
        this.type = this.parseProperty(data, 'type');
        this.installationId = this.parseProperty(data, 'installationId');
        this.allRepositories = this.parseProperty(data, 'allRepositories');
        this.suspended = this.parseProperty(data, 'suspended');
    }
}
